"use strict";

exports.__esModule = true;
exports.MetricChartContextMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Metrics = require("../../../Catalogs/Metrics");
var _Utils = require("../../../Utils");
var _Core = require("../../Core");
var _TimeContext = require("../../Time/TimeContext");
var _timeDefinitions = require("../../timeDefinitions");
var _dec, _class, _MetricChartContextMenu;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function getExportValueForUnit(units, value) {
  switch (units) {
    case "MILLISECOND":
      return Math.round(Number(value) / _timeDefinitions.SECOND_IN_MILLIS);
    // convert to seconds
    case "FRACTIONAL_PERCENT":
      return Number(value).toFixed(4);
    default:
      return value;
  }
}
function getExportUnitName(units) {
  switch (units) {
    case "MILLISECOND":
      return "(s)";
    default:
      return "";
  }
}
var MetricChartContextMenu = exports.MetricChartContextMenu = (_dec = _TimeContext.TimeContext.withContext, (0, _Core.withTranslator)(_class = _dec(_class = (_MetricChartContextMenu = /*#__PURE__*/function (_Component) {
  function MetricChartContextMenu() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleDownload = function () {
      var _this$props = _this.props,
        data = _this$props.data,
        time = _this$props.time;

      // Data is in nested arrays so go through and flatten it all in to an object
      var processedData = data.reduce(function (acc, metricData) {
        var metric = (0, _Metrics.getMetricDefinition)(metricData.metricName);
        metricData.data.forEach(function (dataItem) {
          acc.push({
            metric: metric.label + " " + getExportUnitName(metric.units),
            timestamp: time.toPlantDate(new Date(dataItem.key)).toISOString().replace("T", " ").replace("Z", ""),
            value: getExportValueForUnit(metric.units, dataItem.value)
          });
        });
        return acc;
      }, []);
      var formattedData = (0, _Utils.exportDataToCSVFormat)(processedData);
      (0, _Utils.downloadCSVData)(formattedData, "metricchart");
    };
    _this.handleContextMenu = function (e) {
      var translator = _this.props.translator;
      e.preventDefault();
      var menu = /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, translator.intl, /*#__PURE__*/_react["default"].createElement(_core.Menu, {
        "data-testid": "ContextMenu"
      }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        icon: _icons.IconNames.DOWNLOAD,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ContextMenu.download",
          defaultMessage: "Download"
        }),
        onClick: _this.handleDownload
      })));
      (0, _core.showContextMenu)({
        content: menu,
        targetOffset: {
          left: e.clientX,
          top: e.clientY
        }
      });
    };
    return _this;
  }
  _inheritsLoose(MetricChartContextMenu, _Component);
  var _proto = MetricChartContextMenu.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      children = _this$props2.children,
      width = _this$props2.width,
      height = _this$props2.height;
    return /*#__PURE__*/_react["default"].createElement("div", {
      onContextMenu: this.handleContextMenu,
      style: {
        width: width,
        height: height
      }
    }, children);
  };
  return MetricChartContextMenu;
}(_react.Component), _MetricChartContextMenu.defaultProps = {
  translator: undefined,
  time: undefined,
  data: []
}, _MetricChartContextMenu)) || _class) || _class);